import React from 'react';
import './GeneralArithmeticQuizQuestion.css';

function GeneralQuizQuestion({ question, handleAnswer }) {

  const btnStyle = {
    margin: '5px',
    padding: '4px 8px',
    fontSize: '12px',
    border: 'none',
    borderRadius: '5px',
    backgroundColor: '#4f4f4f',
    color: 'white',
    cursor: 'pointer'
  };
  
  return (
    <div className="question-container">
      <h2>{question.question}</h2>
      <div className="answers-container">
        {question.answers.map((answer, index) => (
          <button key={index} onClick={() => handleAnswer(answer)} style={btnStyle}> 
            {answer}
          </button>
        ))}
      </div>
    </div>
  );
}

export default GeneralQuizQuestion;
